import { render, staticRenderFns } from "./FoldMenu.vue?vue&type=template&id=09751531&scoped=true"
import script from "./FoldMenu.vue?vue&type=script&lang=js"
export * from "./FoldMenu.vue?vue&type=script&lang=js"
import style0 from "./FoldMenu.vue?vue&type=style&index=0&id=09751531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09751531",
  null
  
)

export default component.exports